"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function vueI18nBodyGenerator(languages, preferredLanguage, fallbackLanguage) {
  return {
    locale: preferredLanguage,
    // set locale
    fallbackLocale: fallbackLanguage,
    messages: Object.freeze(languages) // set locale messages

  };
}

var _default = vueI18nBodyGenerator;
exports.default = _default;